import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Grid,
  IconButton,
  useMediaQuery
} from '@mui/material'
import { useState } from 'react'
import { flexItemCenter } from '../../global'
import { makeStyles } from '@mui/styles'
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone'
import { useNavigate, useParams } from 'react-router-dom'
import { appTheme } from '../../theme'
import { deleteSeriesEvent } from '../../services/EventService'
import TrashIcon from '../../images/trashIcon.svg'
import { CustomDialog } from '../../components/CustomDialog'

const useStyles = makeStyles({
  dailogBox: {
    height: 'auto',
    width: '15rem',
    textAlign: 'center'
  },
  overflowWrapper: {
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '6px',
      height: '6px'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'inherit'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#D9D9D9',
      borderRadius: '1.25rem'
    }
  },
  stickyColumn: {
    position: 'sticky',
    left: 0,
    backgroundColor: '#F3F3F3',
    zIndex: 2
  },
  stickyHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 3,
    width: '100%',
    backgroundColor: '#F3F3F3'
  }
})

const DeleteEvent = (data: {
  eventId: number
  decreaseEventsCount: any
  events: [any]
  eventsCount: number
}) => {
  const classes = useStyles()
  const [open, setOpen] = useState(false)
  const fullScreen = useMediaQuery(appTheme.breakpoints.down('md'))
  let { id } = useParams()
  const navigate = useNavigate()

  const refereshPage = () => {
    let currentEventId = data.events[0].id
    if (Number(id) === data.eventId) {
      data.events.map((item, index) => {
        if (item.id === data.eventId) {
          currentEventId = data.events[index + 1].id
        }
      })
    }
    navigate('/dateAndTime/' + currentEventId)
    window.location.reload()
  }

  const deleteEvent = async (eventId: number) => {
    let isDeleted = 0
    try {
      const { data } = await deleteSeriesEvent(eventId)
      if (data) {
        if (data.deleteSeriesEvent.statusCode === 200) {
          isDeleted = 1
        }
      }
    } catch (error) {
      console.log(error)
    }
    return isDeleted
  }
  const handleDelete = async () => {
    let isDeleted = await deleteEvent(data.eventId)
    if (isDeleted) {
      if (Number(id) === data.eventId) {
        refereshPage()
      }
      data.decreaseEventsCount(data.eventId)
    }
    setOpen(false)
  }

  return (
    <div>
      {data.eventsCount !== 1 && (
        <IconButton onClick={() => setOpen(true)} sx={{ p: '0px' }} size="large">
          <Box component='img' src={TrashIcon} alt='Edit Icon'></Box>
        </IconButton>
      )}
      <CustomDialog
        title='Are you sure you want to delete this event?'
        primaryButtonText='Yes, delete'
        secondaryButtonText='Cancel'
        open={open}
        onClose={() => setOpen(false)}
        onPrimaryButtonClick={handleDelete}
        onSecondaryButtonClick={() => setOpen(false)}
      />
    </div>
  );
}

export default DeleteEvent
